"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _modelUtil = _interopRequireDefault(require("@leverege/model-util"));

var _parse = _interopRequireDefault(require("date-fns/parse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateOpen(model, key, value) {
  if (typeof value !== 'boolean') return false;
  return undefined;
}

function validateTime(value, def) {
  // null is valid
  if (value != null) {
    const v = (0, _parse.default)(value, 'hh:mma', new Date());

    if ((v === null || v === void 0 ? void 0 : v.toString()) === 'Invalid Date') {
      return def;
    }
  }

  return undefined;
}

function validateOpenTime(model, key, value) {
  return validateTime(value, '09:00am');
}

function validateCloseTime(model, key, value) {
  return validateTime(value, '05:00pm');
}

function validate() {}

const TYPE = 'recovr.locationHours.hours';

function create() {
  return {
    type: TYPE,
    open: false // openTime,
    // closeTime,

  };
}

var _default = {
  create,
  validate,
  TYPE,
  ..._modelUtil.default.createAllValue('open', null, {
    validate: validateOpen
  }, {
    defaultValue: false
  }),
  ..._modelUtil.default.createAllValue('openTime', null, {
    validate: validateOpenTime
  }, {
    defaultValue: '09:00am'
  }),
  ..._modelUtil.default.createAllValue('closeTime', null, {
    validate: validateCloseTime
  }, {
    defaultValue: '05:00pm'
  })
};
exports.default = _default;